<template>
  <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
    <FormItem label="关联企业" prop="companyId">
      <Row type="flex">
        <Col span="18">
          <sl-select :disabled="checkEnterprise" :silent="true" :value="form.companyId" :data="enterprises" :filterable="true" @on-change="handleChange"></sl-select>
        </Col>
        <Col span="6" style="text-align:right;">
          <Button type="primary" @click="handleGoto">设置企业</Button>
        </Col>
      </Row>
    </FormItem>

    <FormItem>
      <Button @click="reset()">重置</Button>
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </FormItem>
  </Form>
</template>
<script>
export default {
  data() {
    return {
      modalVisible:false,
      action:null,
      rules: {
        companyId: [ { type:'number',required:true , message: '企业不能为空', trigger: 'blur,change' } ],
      },
      form: {
        companyId:null,
      },
      enterprises:[],
      loading:false,
      checkEnterprise:false
    }
  },

  props:{
    orderId:{

    },
    // 1 手工维护企业 2 关联企业 
    type:{
      type:Number,
      default:1
    },
    datas:{
      type:Object,
      default:function(){
        return {}
      }
    }
  },
  watch:{
    orderId(val){
      if(val){
        this.query()
      }
    },
    datas(val){
      if(val && val.orderId){

      }
    }

  },

  mounted() {},

  created(){

    this.$request.enterpriseFilter({enterpriseCode:''}).then( resp => {
      this.enterprises = (resp.data.list || []).map( i => ({value:i.id , label:i.name}))
      //this.enterprises = [{value:1 , label:'以太科技'}]
      if( this.orderId ){
        this.query()
      }
    })
  },
  methods: {
    init(id) {
      this.orderId = id
    },

    query(){
      console.log(this.orderId )

      this.$request.orderCompanyQuery(this.orderId).then(resp => {
        if(!resp.code){
          this.def = resp.data || {}
          this.$utils.fill(this.form , this.def)
          //console.log( this.form )

        }else{
          this.$Message.error({content:resp.message})
        }
      })
      
    },


    save() {
      let params = { orderId: this.orderId , ...this.form }

      this.loading = true
      this.$request.orderCompanyUpdate(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
          this.modalVisible = false
        }
        this.loading = false
      })

    },
    reset(){
      this.$utils.fill(this.form , this.def)
    },

    handleGoto(){
      this.$router.setRouteByCode( 'credit.enterprise.list' )
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误')
        }
      })
    },

    handleChange(companyId){
      if( companyId ){
        this.checkEnterprise = true
        this.$request.enterpriseValidate(companyId , this.orderId).then( resp => {
          this.checkEnterprise = false
          if( !resp.code ){
            this.form.companyId = companyId
            this.$refs['form'].validate()
          }else{
            this.$Notice.error({
              title: '企业信息未完善',
              content:resp.msg
            })
            this.form.companyId = undefined
            this.$refs['form'].resetFields()
          }
        })
      }
    }
  }
}
</script>